import { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { notification } from 'antd';

import { getUserInfo, tenantLogin } from '@/services/token';

enum QueryString {
  tenantId = 'tenantId',
  courseHash = 'courseHash'
}

export const useTenant = (isAuthenticated: boolean) => {
  const loading = useRef(false);
  const navigate = useNavigate();

  const login = useCallback(
    (tenantId: number, courseHash?: string) => {
      tenantLogin(tenantId)
        .then(() => {
          courseHash && navigate('/curso/' + courseHash);
          !courseHash && navigate('/resumo');
        })
        .catch(() => {
          notification.error({ message: 'Não foi possível usar o controle de acesso!' });
          navigate('/resumo');
        });
    },
    [navigate]
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tenantId = parseInt(urlParams.get(QueryString.tenantId) ?? null);
    const courseHash = urlParams.get(QueryString.courseHash) ?? null;
    const userInfo = getUserInfo();

    if (!tenantId || !isAuthenticated || loading.current) {
      return;
    }

    if (userInfo?.tenant_id !== tenantId) {
      loading.current = true;
      login(tenantId, courseHash);
    }
  }, [login, isAuthenticated]);
};
